import { Popover, Typography } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { findLinkBy } from '../../../../../../../Links';
import { Link } from '../../../../../../../Resource/Types';
import EmptyLogo from '../../../../../Details/EmptyLogo';
import { PreviewResource } from '../../../LearningCollectionPreviewStore/Types';
import { T } from '../../../../../../../Translations';

interface Props {
  resource: PreviewResource;
}

function OrgLogo({ resource }: Props) {
  return findLinkBy({ rel: 'logo' }, resource.links)
    .map(({ href, rel }: Link) => (
      <Popover
        trigger="hover"
        className="max-w-[21.625rem] !bg-gray-700"
        renderTrigger={(ref, getReferenceProps) => {
          const { 'aria-expanded': _, 'aria-haspopup': __, ...imgProps } = getReferenceProps();
          return (
            <div className="h-full max-h-96 w-full max-w-sm overflow-hidden flex justify-end">
              <img
                ref={ref}
                {...imgProps}
                src={href}
                alt={rel}
                className="h-auto max-h-96 max-w-96 object-cover"
              />
            </div>
          );
        }}
        children={
          <Typography variant="bodyMedium" color="white">
            <T kind="Your organization logo is displayed here - you can change or remove this logo by editing the collection later" />
          </Typography>
        }
      />
    ))
    .getOrElse(() => <EmptyLogo />);
}

export default observer(OrgLogo);
